import { AiAgents, AiTeamsImpact, AiTeamsImpactLang, CaseStudies, CrmNav, Departments, DepartmentsProjectsTest, MondayDifference, Products, Security, Trust, Closer, Logos, Hero, HeroFu, BrightHeroLeftPannel, CloserLlama, LotemHero, LHeroHover, LHeroVideos, HeroEldadVarB, HeroEldadVarC, ShorterHero1, ShorterHero2, Gartner, TrustNav } from "devlink";
import AiAgentsConfig from "../configs/aiagents-config";
import AiTeamsImpactConfig from "../configs/aiteamsimpact-config";
import AiTeamsImpactLangConfig from "../configs/aiteamsimpactlang-config";
import CaseStudiesConfig from "../configs/casestudies-config";
import CloserLlamaConfig from "../configs/closerllama-config";
import MondayDifferenceConfig from "../configs/mondaydifference-config";
import ProductsConfig from "../configs/products-config";
import SecurityConfig from "../configs/security-config";
import TrustConfig from "../configs/trust-config";
import DepartmentsConfig from "../configs/departments-config";
import DepartmentsDefaultProps from "../configs/default-props/departments-default-props";
import AiAgentsDefaultProps from "../configs/default-props/aiagents-default-props";
import AiTeamsImpactDefaultProps from "../configs/default-props/aiteamsimpact-default-props";
import AiTeamsImpactLangDefaultProps from "../configs/default-props/aiteamsimpactlang-default-props";
import CaseStudiesDefaultProps from "../configs/default-props/casestudies-default-props";
import CloserLlamaDefaultProps from "../configs/default-props/closerllama-default-props";
import MondayDifferenceDefaultProps from "../configs/default-props/mondaydifference-default-props";
import ProductsDefaultProps from "../configs/default-props/products-default-props";
import SecurityDefaultProps from "../configs/default-props/security-default-props";
import TrustDefaultProps from "../configs/default-props/trust-default-props";
import DevlinkMagicConfig from "../components/devlink-magic/devlink-magic-config";
import LHeroHoverConfig from "../components/l-hero-hover/l-hero-hover-config";
import DevlinkMagicComponent from "../components/devlink-magic/devlink-magic-component";
import { FIELD_TYPES } from "constants/template-field-type";
import HeroFuConfig from "../configs/hero-fu-config";
export const DEVLINK_COMPONENT_CONFIGS = {
    Hero: {
        component: Hero,
        props: {
            buttonBottomLabel: {
                type: FIELD_TYPES.TEXT,
                label: "Button Bottom Label",
                translatable: true
            },
            buttonLabelVisibility: {
                type: FIELD_TYPES.BOOLEAN,
                label: "Show Button Label"
            }
        }
    },
    HeroFu: {
        component: HeroFu,
        props: HeroFuConfig
    },
    Products: {
        component: Products,
        props: ProductsConfig,
        defaultProps: ProductsDefaultProps
    },
    Departments: {
        component: Departments,
        props: DepartmentsConfig,
        defaultProps: DepartmentsDefaultProps
    },
    DepartmentsProjectsTest: {
        component: DepartmentsProjectsTest,
        props: {}
    },
    AiTeamsImpact: {
        component: AiTeamsImpact,
        props: AiTeamsImpactConfig,
        defaultProps: AiTeamsImpactDefaultProps
    },
    AiTeamsImpactLang: {
        component: AiTeamsImpactLang,
        props: AiTeamsImpactLangConfig,
        defaultProps: AiTeamsImpactLangDefaultProps
    },
    Trust: {
        component: Trust,
        props: TrustConfig,
        defaultProps: TrustDefaultProps
    },
    Security: {
        component: Security,
        props: SecurityConfig,
        defaultProps: SecurityDefaultProps
    },
    AiAgents: {
        component: AiAgents,
        props: AiAgentsConfig,
        defaultProps: AiAgentsDefaultProps
    },
    CaseStudies: {
        component: CaseStudies,
        props: CaseStudiesConfig,
        defaultProps: CaseStudiesDefaultProps
    },
    MondayDifference: {
        component: MondayDifference,
        props: MondayDifferenceConfig,
        defaultProps: MondayDifferenceDefaultProps
    },
    Closer: {
        component: Closer,
        props: {}
    },
    Logos: {
        component: Logos,
        props: {}
    },
    Magic: {
        component: DevlinkMagicComponent,
        props: DevlinkMagicConfig
    },
    BrightHeroLeftPannel: {
        component: BrightHeroLeftPannel,
        props: {}
    },
    CloserLlama: {
        component: CloserLlama,
        props: CloserLlamaConfig,
        defaultProps: CloserLlamaDefaultProps
    },
    LotemHero: {
        component: LotemHero,
        props: {}
    },
    CrmNav: {
        component: CrmNav,
        props: {}
    },
    LHeroHover: {
        component: LHeroHover,
        props: LHeroHoverConfig
    },
    LHeroVideos: {
        component: LHeroVideos,
        props: {}
    },
    HeroEldadVarB: {
        component: HeroEldadVarB,
        props: {}
    },
    HeroEldadVarC: {
        component: HeroEldadVarC,
        props: {}
    },
    ShorterHero1: {
        component: ShorterHero1,
        props: {}
    },
    ShorterHero2: {
        component: ShorterHero2,
        props: {}
    },
    Gartner: {
        component: Gartner,
        props: {}
    },
    TrustNav: {
        component: TrustNav,
        props: {}
    }
};
